// extracted by mini-css-extract-plugin
export default {"sort":"sort_sort__FJO6i","section":"sort_section__IBhkG","title":"sort_title__B5NEk"};